import { Text } from '@components/rolex-ui/Text'
import { formatPrice } from '@lib/formatPrice'
import * as Popover from '@radix-ui/react-popover'
import { useTranslation } from 'next-i18next'
import React, { FC } from 'react'

type RolexProductPageHeroPriceProps = {
  price: number
}

export const RolexProductPageHeroPrice: FC<RolexProductPageHeroPriceProps> = ({ price }) => {
  const { t } = useTranslation('other')
  return (
    <div className="flex items-center gap-2">
      <Text variant="body20" weight="light" as="span">
        {formatPrice(price * 100)}
      </Text>
      <Popover.Root>
        <Popover.Trigger>
          <button className="flex h-4 w-4 items-center justify-center rounded-full border border-solid border-rolexShade-900 opacity-100 outline-none transition-opacity duration-100 hover:opacity-80">
            <svg height="8" width="8" viewBox="0 0 11 11" fill="currentColor">
              <path d="m6.08 8.59.85.36-.17.34c-.03.08-.11.21-.19.38-.1.19-.24.39-.41.59-.18.2-.4.37-.66.51-.27.15-.6.23-.97.23-.41 0-.74-.09-1-.27-.21-.14-.45-.44-.45-1 0-.21.04-.44.11-.68.06-.21.13-.42.19-.6l1.41-4.05h-1.33l.26-.93h3.2l-1.97 5.72c-.05.15-.1.3-.15.46-.03.13-.05.24-.05.35 0 .05.01.07.02.09.01 0 .02.01.05.01.08 0 .18-.04.28-.11.13-.1.26-.21.37-.34.12-.13.22-.26.3-.4.08-.15.13-.26.17-.34zm1.32-8.28c-.21-.2-.47-.31-.77-.31s-.56.11-.76.31-.31.48-.31.78.11.56.31.77.47.31.76.31.56-.11.77-.31c.2-.21.31-.48.31-.77 0-.3-.11-.57-.31-.78z" />
            </svg>
          </button>
        </Popover.Trigger>
        <Popover.Content
          sideOffset={5}
          side="top"
          align="center"
          className="max-w-[280px] rounded-sm bg-white p-3 shadow-md"
        >
          <Popover.Arrow className="fill-white" />
          <Text variant="fixed14" weight="light" as="div" className="!leading-[1.4]">
            {t('rolexPriceDisclaimer')}
          </Text>
        </Popover.Content>
      </Popover.Root>
    </div>
  )
}
